export default __webpack_public_path__ + "static/media/unban.c82511df.svg";